

/* 
*设置为有次级菜单的菜单（TODO：无法判断二级是tab还是次级菜单， 暂时先这样写，总台path需要和这里统一）
*/
export const threeMenu = [];